// extracted by mini-css-extract-plugin
export default {"badge":"badge-module__badge___lIGn6"};